// Shared Google Maps styling for Client Portal
// Pastel color scheme with light, airy aesthetic

export const PASTEL_MAP_STYLES = [
  // Global - reduce saturation for more muted/gray feel
  {
    stylers: [{ saturation: -40 }],
  },
  // Water - soft pastel blue
  {
    featureType: "water",
    elementType: "geometry",
    stylers: [{ color: "#d4ebf2" }],
  },
  {
    featureType: "water",
    elementType: "labels.text.fill",
    stylers: [{ color: "#92a9b3" }],
  },
  // Landscape - very light pastel
  {
    featureType: "landscape",
    elementType: "geometry",
    stylers: [{ color: "#f7f8fa" }],
  },
  // Roads - soft neutral tones
  {
    featureType: "road",
    elementType: "geometry",
    stylers: [{ color: "#ffffff" }],
  },
  {
    featureType: "road",
    elementType: "geometry.stroke",
    stylers: [{ color: "#e8eaed" }],
  },
  {
    featureType: "road",
    elementType: "labels.text.fill",
    stylers: [{ color: "#9ca5b3" }],
  },
  {
    featureType: "road.highway",
    elementType: "geometry",
    stylers: [{ color: "#f8f9fa" }],
  },
  {
    featureType: "road.highway",
    elementType: "geometry.stroke",
    stylers: [{ color: "#e8eaed" }],
  },
  // Administrative boundaries - subtle
  {
    featureType: "administrative",
    elementType: "geometry.stroke",
    stylers: [{ color: "#e0e3e8" }],
  },
  {
    featureType: "administrative",
    elementType: "labels.text.fill",
    stylers: [{ color: "#9ca5b3" }],
  },
  // POI - hide most, keep parks light
  {
    featureType: "poi",
    elementType: "labels",
    stylers: [{ visibility: "off" }],
  },
  {
    featureType: "poi.park",
    elementType: "geometry",
    stylers: [{ color: "#e8f5e9" }],
  },
  // Transit - show lines, simplify labels
  {
    featureType: "transit.line",
    elementType: "geometry",
    stylers: [{ visibility: "on" }, { color: "#b0b5bd" }],
  },
  {
    featureType: "transit.station",
    elementType: "labels",
    stylers: [{ visibility: "simplified" }],
  },
]

// Near-grayscale variant for transactions map
export const DESATURATED_MAP_STYLES = [
  // Global - heavily desaturated, almost grayscale
  {
    stylers: [{ saturation: -85 }, { lightness: 10 }],
  },
  // Water - very light gray-blue
  {
    featureType: "water",
    elementType: "geometry",
    stylers: [{ color: "#e8eef1" }],
  },
  {
    featureType: "water",
    elementType: "labels.text.fill",
    stylers: [{ color: "#b0b8be" }],
  },
  // Landscape - near white
  {
    featureType: "landscape",
    elementType: "geometry",
    stylers: [{ color: "#f5f6f8" }],
  },
  // Roads - white with light gray stroke
  {
    featureType: "road",
    elementType: "geometry",
    stylers: [{ color: "#ffffff" }],
  },
  {
    featureType: "road",
    elementType: "geometry.stroke",
    stylers: [{ color: "#e8eaed" }],
  },
  {
    featureType: "road",
    elementType: "labels.text.fill",
    stylers: [{ color: "#b0b5bd" }],
  },
  {
    featureType: "road.highway",
    elementType: "geometry",
    stylers: [{ color: "#f0f1f3" }],
  },
  {
    featureType: "road.highway",
    elementType: "geometry.stroke",
    stylers: [{ color: "#e0e2e6" }],
  },
  // Administrative - very subtle
  {
    featureType: "administrative",
    elementType: "geometry.stroke",
    stylers: [{ color: "#e0e3e8" }],
  },
  {
    featureType: "administrative",
    elementType: "labels.text.fill",
    stylers: [{ color: "#b0b5bd" }],
  },
  // POI - hide most, parks barely visible
  {
    featureType: "poi",
    elementType: "labels",
    stylers: [{ visibility: "off" }],
  },
  {
    featureType: "poi.park",
    elementType: "geometry",
    stylers: [{ color: "#eef2ef" }],
  },
  // Transit - very subtle
  {
    featureType: "transit.line",
    elementType: "geometry",
    stylers: [{ visibility: "on" }, { color: "#d0d3d8" }],
  },
  {
    featureType: "transit.station",
    elementType: "labels",
    stylers: [{ visibility: "simplified" }],
  },
]

// Figma brand colors for custom markers
export const PIN_COLORS = {
  CARIBBEAN: "#50e3c2",
  BRAND_BLUE: "#0086e6",
  BRAND_RED: "#FF3059",
}

/**
 * Helper function to create custom pin icons matching Figma design
 * @param {string} color - Hex color code for the pin
 * @param {google.maps} google - Google Maps API object
 * @param {number} scale - Scale factor for the icon (default: 1.5)
 * @returns {google.maps.Icon} Pin icon configuration
 */
export function createCustomPinIcon(color, google, scale = 1.5) {
  return {
    path: "M12 0C7.58 0 4 3.58 4 8c0 5.5 8 13 8 13s8-7.5 8-13c0-4.42-3.58-8-8-8zm0 11c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z",
    fillColor: color || PIN_COLORS.CARIBBEAN,
    fillOpacity: 1,
    strokeColor: "#ffffff",
    strokeWeight: 2,
    scale: scale,
    anchor: new google.maps.Point(12, 24),
  }
}
